import mapKnownValues from "@/utils/mapKnownValues";
import Address from "@/classes/address";
import Property from "@/classes/property";
import Station from "@/classes/station";

export type OrganizationAPIResponse = {
  id: string;
  name: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  email: string;
  manager: string;
  note: string;
};

export default class Organization {
  id = "";
  address1 = "";
  address2 = "";
  city = "";
  state = "";
  zip = "";
  phone = "";
  email = "";
  manager = "";
  name = "";
  note = "";

  // Outside of response
  properties: Property[] = [];
  stations: Station[] = [];

  constructor(params: Partial<Organization> = {}) {
    mapKnownValues(this, params);
  }

  get address() {
    return new Address(this);
  }

  toJson() {
    return {
      ...this,
      properties: undefined,
      stations: undefined
    };
  }

  static fromAPIResponse(response: OrganizationAPIResponse, properties: Property[] = [], stations: Station[] = []) {
    const mappedProperties = properties.map(
      property =>
        new Property({
          ...property,
          stations: stations.filter(station => station.propertyId === property.id)
        })
    );
    const mappedStations = stations.map(station => new Station(station));
    return new Organization({
      ...response,
      properties: mappedProperties,
      stations: mappedStations
    });
  }
}
